import styled from 'styled-components';

// ===========================================================================
// Estilos locais do DETALHE do movimento (2026-09-12, redesenho).
//
// O arquivo antes era código morto (estilos Geração 1 sem nenhum import —
// débito #4 do doc de arquitetura do módulo) e foi reescrito no lugar.
//
// Aqui vive só o que não é primitivo do kit: a grade de leitura
// caption/valor que substituiu os `<input disabled>` e o aviso de vínculo com
// transferência. Botões, pílulas, tabela e barra de ações vêm de
// `styles/ui/*` e `components/StatusBadge`.
// ===========================================================================

// Grade de leitura: cada par é uma legenda caixa-alta + o valor. Trocar input
// desabilitado por texto foi decisão do redesenho — campo desabilitado sugere
// "editável, mas não agora", e o detalhe é somente leitura por natureza (a
// edição tem tela própria).
export const DataGrid = styled.dl`
   display: grid;
   grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
   gap: 18px 24px;
   margin: 0;
`;

export const DataItem = styled.div`
   min-width: 0;
   grid-column: ${({ $span }) => ($span ? `span ${$span}` : 'auto')};

   dt {
      font-size: 11px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      color: ${({ theme }) => theme.colors.textMuted};
   }

   dd {
      margin: 4px 0 0;
      font-size: 14px;
      line-height: 1.45;
      color: ${({ theme }) => theme.colors.textPrimary};
      overflow-wrap: anywhere;
   }

   dd.strong {
      font-weight: 700;
   }

   @media (max-width: 640px) {
      grid-column: auto;
   }
`;

export const HeadPills = styled.div`
   display: inline-flex;
   align-items: center;
   gap: 8px;
   flex-wrap: wrap;
`;

// Aviso do movimento que pertence a uma transferência entre PDVs — ele não é
// editável nem excluível por aqui (a trava real é o 409 do backend; este
// banner e o sumiço dos botões existem para o operador não descobrir no erro).
// ⚠️ Fundo BRANCO, não azul translúcido (correção 2026-08-22): o aviso fica
// fora dos cartões, direto sobre o fundo escuro do shell, onde um
// `rgba(24,95,165,0.08)` some e o texto perde contraste de leitura. Cor no
// aviso é a faixa lateral, não o fundo.
export const TransferNote = styled.div`
   display: flex;
   align-items: flex-start;
   gap: 10px;
   margin-bottom: 14px;
   padding: 12px 14px;
   border-radius: 8px;
   border: 1px solid ${({ theme }) => theme.colors.border};
   border-left: 4px solid ${({ theme }) => theme.colors.link};
   background: ${({ theme }) => theme.colors.surface};
   box-shadow: ${({ theme }) => theme.shadows.sm};
   font-size: 12.5px;
   line-height: 1.55;
   color: rgba(0, 0, 0, 0.78);

   strong {
      color: rgba(0, 0, 0, 0.9);
   }

   .ic {
      flex-shrink: 0;
      margin-top: 2px;
      color: ${({ theme }) => theme.colors.link};
   }

   .act {
      margin-left: auto;
      flex-shrink: 0;
   }
`;

// Rodapé da tabela de itens (total de linhas e de unidades).
export const TotalRow = styled.tr`
   td {
      background: #fafafb;
      font-weight: 800;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.04em;
   }
`;
